import './index';
import { loadFeatures } from '../../tools/features';
import { injectAuthScript } from '../../tools/injectAuthScript';

const initLoad = async () => {
  await loadFeatures();
  injectAuthScript();
};

initLoad();
